// Module
var code = "<template> <require from=\"app/core/components/genders/genders\"></require> <genders></genders> </template> ";
// Exports
module.exports = code;